export const COOKIE_CONSENT_VERSION = 1 as const;

export type CookieCategoryId = 'essential' | 'functional' | 'analytics';

export type CookieCategoryDefinition = {
  id: CookieCategoryId;
  required: boolean;
  /** i18n anahtarları: privacy namespace altında cookie.category.{id}.* */
  titleKey: string;
  descriptionKey: string;
};

export type CookieConsentPreferences = Record<CookieCategoryId, boolean>;

export type CookieConsentRecord = {
  version: typeof COOKIE_CONSENT_VERSION;
  updatedAt: string;
  preferences: CookieConsentPreferences;
};
